import { useRef } from 'react';

import { HttpResolver } from '../core/http-resolver';

export const envoyWebHttpResolver = new HttpResolver('envoyWeb');

export function useEnvoyWeb(basePath?: string) {
  const envoyWebClient = useRef(envoyWebHttpResolver.resolve(basePath));

  return envoyWebClient.current;
}
